import { render, staticRenderFns } from "./BenchmarkSearchAndFilter.vue?vue&type=template&id=510f7fbc"
import script from "./BenchmarkSearchAndFilter.vue?vue&type=script&lang=js"
export * from "./BenchmarkSearchAndFilter.vue?vue&type=script&lang=js"
import style0 from "./BenchmarkSearchAndFilter.vue?vue&type=style&index=0&id=510f7fbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports